import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const WHATSAPP_REVIEWS = [
  {
    id: 1,
    name: 'Rohit M.',
    avatar: '/assets/images/gen/avatar-rk.svg',
    time: '2:45 PM',
    message: 'Just received my ₹85,000 winning amount! Thank you Nitin team for the quick payout 🎉',
  },
  {
    id: 2,
    name: 'Sneha K.',
    avatar: '/assets/images/gen/avatar-sr.svg',
    time: '11:30 AM',
    message: 'The customer support is amazing! Got help within 2 minutes on WhatsApp. Very professional team 👍',
  },
  {
    id: 3,
    name: 'Vikash P.',
    avatar: '/assets/images/gen/avatar-vm.svg',
    time: 'Yesterday',
    message: 'Nitin online book app download link came instantly and installed clean. Playing on mobile all week now.',
  },
  {
    id: 4,
    name: 'Deepa S.',
    avatar: '/assets/images/gen/avatar-ds.svg',
    time: 'Yesterday',
    message: 'Asked for a deposit limit and they set it the same day without arguing. That says a lot about a platform.',
  },
];

const SOCIAL_REVIEWS = [
  {
    id: 5,
    name: 'Arjun Reddy',
    avatar: '/assets/images/gen/avatar-ar.svg',
    platform: 'Instagram',
    handle: '@arjun.plays',
    message: 'Third withdrawal this month, every single one under 6 minutes. Nitin Online Book is the real deal.',
    likes: 342,
  },
  {
    id: 6,
    name: 'Kavya Sharma',
    avatar: '/assets/images/gen/avatar-kt.svg',
    platform: 'Telegram',
    handle: 'Nitin VIP community',
    message: 'The strategy pack they send free is better than most paid courses. Bankroll rules changed my game.',
    likes: 218,
  },
  {
    id: 7,
    name: 'Manoj Kumar',
    avatar: '/assets/images/gen/avatar-mj.svg',
    platform: 'Instagram',
    handle: '@manoj_teenpatti',
    message: 'Signed up in two minutes on WhatsApp, played Teen Patti the same night. Zero paperwork drama.',
    likes: 487,
  },
  {
    id: 8,
    name: 'Harsh P.',
    avatar: '/assets/images/gen/avatar-hp.svg',
    platform: 'Telegram',
    handle: 'Nitin VIP community',
    message: 'Support answered at 2 AM when my UPI bounced. Fixed and paid before I went to sleep.',
    likes: 156,
  },
];

const TABS = [
  { id: 'whatsapp', name: 'WhatsApp reviews', icon: 'MessageCircle' },
  { id: 'social', name: 'Social media', icon: 'Share2' },
];

const SocialProofSection = () => {
  const [tab, setTab] = useState('whatsapp');

  return (
    <section className="relative overflow-hidden py-24">
      <span className="aurora left-[-8%] top-[14%] h-96 w-96 bg-wa-green/20" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <span className="badge-pill"><Icon name="Quote" size={13} /> Unfiltered feedback</span>
          <h2 className="mt-6 font-heading text-display font-bold text-white">
            What players say when <span className="gold-text">nobody asks them to</span>
          </h2>
          <p className="mt-4 text-body-lg text-white/60">
            Screenshots from the desk and posts from the community, published exactly as they were written.
          </p>
        </div>

        <div className="mt-10 flex justify-center gap-2">
          {TABS.map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium transition ${
                tab === t.id
                  ? 'bg-gradient-royal text-[#150F02] shadow-[0_10px_22px_-14px_rgba(240,194,75,0.95)]'
                  : 'border border-white/10 bg-white/[0.05] text-white/60 hover:text-white'
              }`}
            >
              <Icon name={t.icon} size={15} /> {t.name}
            </button>
          ))}
        </div>

        {tab === 'whatsapp' ? (
          <div className="mt-10 grid gap-5 md:grid-cols-2">
            {WHATSAPP_REVIEWS.map((r) => (
              <div
                key={r.id}
                className="animate-fade-in rounded-2xl border border-white/8 p-5"
                style={{
                  backgroundColor: '#080B10',
                  backgroundImage: 'url("/assets/images/gen/royal-pattern.svg")',
                  backgroundSize: '120px 120px',
                }}
              >
                <div className="flex items-start gap-3">
                  <Image src={r.avatar} alt={r.name} className="h-11 w-11 shrink-0 rounded-full" />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-baseline justify-between gap-3">
                      <span className="font-display text-sm font-semibold text-white">{r.name}</span>
                      <span className="text-[0.62rem] text-white/35">{r.time}</span>
                    </div>
                    <div className="mt-2 rounded-2xl rounded-tl-md border border-white/10 bg-[#141C23] px-4 py-3 text-sm leading-relaxed text-white/80">
                      {r.message}
                      <span className="mt-1 block text-right text-[0.6rem] text-wa-green">✓✓ read</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-10 grid gap-5 md:grid-cols-2">
            {SOCIAL_REVIEWS.map((r) => (
              <div key={r.id} className="card-flat animate-fade-in p-6">
                <div className="flex items-center gap-3">
                  <Image src={r.avatar} alt={r.name} className="h-11 w-11 rounded-full" />
                  <div className="min-w-0 flex-1">
                    <div className="font-display text-sm font-semibold text-white">{r.name}</div>
                    <div className="text-xs text-white/45">{r.handle} · {r.platform}</div>
                  </div>
                  <Icon
                    name={r.platform === 'Instagram' ? 'Instagram' : 'Send'}
                    size={18}
                    color={r.platform === 'Instagram' ? '#FF3D71' : '#5B8CFF'}
                  />
                </div>
                <p className="mt-4 text-sm leading-relaxed text-white/65">{r.message}</p>
                <div className="mt-4 flex items-center gap-2 text-xs text-white/40">
                  <Icon name="Heart" size={13} color="#FF3D71" /> {r.likes} likes
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default SocialProofSection;
